import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'

// initial state
const state = {
  lists: '',
}

// getters
const getters = {
  getLists: (state) => () => {
    if (!state) return undefined
    if (!state.lists) return undefined

    return state.lists
  },
}

// actions
const actions = {
  bindLists: firebaseAction(context => {
    return context.bindFirebaseRef('lists', db.ref('fishing'))
  }),
}

// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
